export const getCollectionCount = (value) => {
  if (Array.isArray(value)) {
    return value.length;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (!value) {
    return 0;
  }

  if (typeof value === 'object') {
    if (typeof value.count === 'number' && Number.isFinite(value.count)) {
      return value.count;
    }

    if (typeof value.total === 'number' && Number.isFinite(value.total)) {
      return value.total;
    }

    return Object.keys(value).length;
  }

  return 0;
};

export default getCollectionCount;
